import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, FileText, Calendar, Download, Clock, Users, CheckCircle, AlertCircle } from 'lucide-react';
import { GrasrotandelenBanner } from '../components/GrasrotandelenBanner';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

const getprotocolData = () => ({
  '2025': {
    year: '2025',
    date: t('pg.AarsmoeteprotokollYear.6a0b6d'),
    status: 'available',
    title: t('pg.AarsmoeteprotokollYear.54ec09'),
    intro: t('pg.AarsmoeteprotokollYear.0f6b9b'),
    details: [
      { label: t('pg.AarsmoeteprotokollYear.1b3140'), value: t('pg.AarsmoeteprotokollYear.6a0b6d') },
      { label: t('pg.AarsmoeteprotokollYear.984fd2'), value: t('pg.AarsmoeteprotokollYear.933b70') },
      { label: t('pg.AarsmoeteprotokollYear.60f643'), value: t('pg.AarsmoeteprotokollYear.b746de') },
    ],
    sections: [
      t('pg.AarsmoeteprotokollYear.91cff9'),
      t('pg.AarsmoeteprotokollYear.f498a9'),
      t('pg.AarsmoeteprotokollYear.4c6ca5'),
      t('pg.AarsmoeteprotokollYear.a084f4'),
      t('pg.AarsmoeteprotokollYear.f9da0f'),
      t('pg.AarsmoeteprotokollYear.91e9a1'),
      t('pg.AarsmoeteprotokollYear.9edfe6'),
    ],
    documents: [
      {
        name: t('pg.AarsmoeteprotokollYear.689978'),
        description: t('pg.AarsmoeteprotokollYear.c7816a'),
        url: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/8ngonwon_Protokoll%20arsmote%202025.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
        featured: true,
      },
      {
        name: t('pg.AarsmoeteprotokollYear.8370df'),
        description: t('pg.AarsmoeteprotokollYear.93e94b'),
        url: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/1asjdlj7_Arsberetning%20for%20Veitvet%20SK%202024.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
      {
        name: t('pg.AarsmoeteprotokollYear.4583a8'),
        description: t('pg.AarsmoeteprotokollYear.ad95e7'),
        url: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/t6mq9lh1_Arsregnskap%2C%20resultat%20og%20balanse%20Veitvet%20SK%202024.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
      {
        name: t('pg.AarsmoeteprotokollYear.ccca75'),
        description: t('pg.AarsmoeteprotokollYear.327cff'),
        url: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/bshrw86i_Budsjett%20for%20Veitvet%20SK%202025.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
      {
        name: t('pg.AarsmoeteprotokollYear.2fa12a'),
        description: t('pg.AarsmoeteprotokollYear.f697e1'),
        url: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/duxojvaj_Kontrollutvalgets%20beretning%20for%202024.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
      {
        name: t('pg.AarsmoeteprotokollYear.d51f8b'),
        description: t('pg.AarsmoeteprotokollYear.746345'),
        url: 'https://customer-assets.emergentagent.com/job_09720358-96bb-48aa-ae6e-95813c643b78/artifacts/x5e2sa6t_Organisasjonsplan%20anno%202025.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
    ],
    placeholder: false,
  },
  '2026': {
    year: '2026',
    date: t('pg.AarsmoeteprotokollYear.1581a6'),
    status: 'available',
    title: t('pg.AarsmoeteprotokollYear.b708d4'),
    intro: t('pg.AarsmoeteprotokollYear.15ebc6'),
    details: [
      { label: t('pg.AarsmoeteprotokollYear.1b3140'), value: t('pg.AarsmoeteprotokollYear.1581a6') },
      { label: t('pg.AarsmoeteprotokollYear.984fd2'), value: t('pg.AarsmoeteprotokollYear.933b70') },
      { label: t('pg.AarsmoeteprotokollYear.ec53a8'), value: t('pg.AarsmoeteprotokollYear.00cae7') },
    ],
    sections: [
      t('pg.AarsmoeteprotokollYear.91cff9'),
      t('pg.AarsmoeteprotokollYear.f498a9'),
      t('pg.AarsmoeteprotokollYear.4c6ca5'),
      t('pg.AarsmoeteprotokollYear.a084f4'),
      t('pg.AarsmoeteprotokollYear.f9da0f'),
      t('pg.AarsmoeteprotokollYear.91e9a1'),
      t('pg.AarsmoeteprotokollYear.9edfe6'),
    ],
    documents: [
      {
        name: t('pg.AarsmoeteprotokollYear.4e0db4'),
        description: t('pg.AarsmoeteprotokollYear.168918'),
        url: 'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/hy02tkyx_Protokoll%20%20-%20%C3%85rsm%C3%B8te%20Veitvet%20Sportsklubb%202026_signert.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
        featured: true,
      },
      {
        name: t('pg.AarsmoeteprotokollYear.5334fa'),
        description: t('pg.AarsmoeteprotokollYear.d69be7'),
        url: 'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/duvb0fb1_%C3%85rsregnskap%202025%20-%20Veitvet%20Sportsklubb_Signert.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
      {
        name: t('pg.AarsmoeteprotokollYear.5efd58'),
        description: t('pg.AarsmoeteprotokollYear.6ed9ec'),
        url: 'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/6oytumi3_Budsjett%202026%20Veitvet%20SK%20hele%20klubben_signert.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
      {
        name: t('pg.AarsmoeteprotokollYear.397c41'),
        description: t('pg.AarsmoeteprotokollYear.557112'),
        url: 'https://customer-assets.emergentagent.com/job_a2119276-b11a-4d90-b267-fc420228fa77/artifacts/zd0xzbhx_Saksliste%20-%20%C3%85rsm%C3%B8te%20Veitvet%20Sportsklubb%202026.pdf',
        type: t('pg.AarsmoeteprotokollYear.bcd1b6'),
      },
    ],
    placeholder: false,
  },
});

export const AarsmoeteprotokollYear = () => {
  useTranslation();
  const { year } = useParams();
  const data = getprotocolData()[year];

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="protocol-not-found">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">{t('pg.AarsmoeteprotokollYear.e8eb88')}</h1>
          <Link to="/aarsmoeteprotokoll">
            <button className="bg-green-500 text-white font-bold px-6 py-3 rounded-lg">
              {t('pg.AarsmoeteprotokollYear.9470c2')}
            </button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div data-testid={`protocol-${year}-page`} className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Link 
            to="/aarsmoeteprotokoll" 
            className="inline-flex items-center gap-2 text-slate-500 hover:text-green-500 transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('pg.AarsmoeteprotokollYear.77aeae')}
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className={`
              w-14 h-14 rounded-xl flex items-center justify-center
              ${data.status === 'available' ? 'bg-green-500' : 'bg-slate-100'}
            `}>
              <FileText className={`w-7 h-7 ${data.status === 'available' ? 'text-white' : 'text-slate-400'}`} />
            </div>
            <div>
              <p className="text-green-500 font-medium uppercase tracking-widest mb-1">{t('pg.AarsmoeteprotokollYear.f871d7')}</p>
              <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter text-slate-900">
                {data.year}
              </h1>
            </div>
          </div>
          
          <p className="text-slate-600 text-lg">
            {data.intro}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-4xl mx-auto">
          {data.status === 'available' ? (
            <>
              {/* Details */}
              <div className="bg-white rounded-2xl border border-white/10 p-6 sm:p-8 mb-8">
                <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                  <Calendar className="w-5 h-5 text-green-500" />
                  {t('pg.AarsmoeteprotokollYear.cc54f4')}
                </h2>
                <div className="grid sm:grid-cols-3 gap-4">
                  {data.details.map((detail, index) => (
                    <div key={index} className="bg-slate-100/50 rounded-xl p-4">
                      <p className="text-slate-400 text-xs uppercase tracking-wider mb-1">{detail.label}</p>
                      <p className="text-slate-900 font-medium">{detail.value}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Sections */}
              {data.sections.length > 0 && (
                <div className="bg-white rounded-2xl border border-white/10 p-6 sm:p-8 mb-8">
                  <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                    <FileText className="w-5 h-5 text-green-500" />
                    {t('pg.AarsmoeteprotokollYear.d0832f')}
                  </h2>
                  <div className="space-y-3">
                    {data.sections.map((section, index) => (
                      <div key={index} className="flex items-center gap-3 text-slate-600">
                        <div className="w-8 h-8 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0">
                          <span className="text-green-500 font-bold text-sm">{index + 1}</span>
                        </div>
                        {section}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Documents */}
              {data.documents && data.documents.length > 0 && (
                <div className="bg-white rounded-2xl border border-green-500/30 p-6 sm:p-8 mb-8">
                  <h2 className="text-xl font-bold text-slate-900 mb-6 flex items-center gap-3">
                    <Download className="w-5 h-5 text-green-500" />
                    {t('pg.AarsmoeteprotokollYear.1d06f8')}
                  </h2>
                  <div className="space-y-4">
                    {data.documents.map((doc, index) => (
                      <a
                        key={index}
                        href={doc.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`flex items-center gap-4 rounded-xl p-4 transition-colors group ${
                          doc.featured 
                            ? 'bg-green-500/10 border border-green-500/30 hover:bg-green-500/20' 
                            : 'bg-slate-100/50 hover:bg-slate-100'
                        }`}
                        data-testid={`document-${index}`}
                      >
                        <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${
                          doc.featured ? 'bg-green-500' : 'bg-red-500/10'
                        }`}>
                          <FileText className={`w-6 h-6 ${doc.featured ? 'text-white' : 'text-red-400'}`} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className={`font-medium group-hover:text-green-500 transition-colors truncate ${
                            doc.featured ? 'text-green-500 text-lg' : 'text-slate-900'
                          }`}>
                            {doc.name}
                          </p>
                          <p className="text-slate-400 text-sm truncate">{doc.description}</p>
                        </div>
                        <div className="flex items-center gap-2 text-slate-500 group-hover:text-green-500 transition-colors flex-shrink-0">
                          <span className="text-xs font-medium uppercase bg-zinc-700 px-2 py-1 rounded">{doc.type}</span>
                          <Download className="w-5 h-5" />
                        </div>
                      </a>
                    ))}
                  </div>
                </div>
              )}

              {/* Placeholder for actual protocol content */}
              {data.placeholder && (
                <div className="bg-green-500/10 border border-green-500/30 rounded-2xl p-6 sm:p-8">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 bg-green-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                      <AlertCircle className="w-5 h-5 text-green-500" />
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-slate-900 mb-2">{t('pg.AarsmoeteprotokollYear.23df01')}</h3>
                      <p className="text-slate-600 mb-4">
                        {t('pg.AarsmoeteprotokollYear.2b96ac')}
                      </p>
                      <Link 
                        to="/contact"
                        className="inline-flex items-center gap-2 text-green-500 font-medium hover:underline"
                      >
                        {t('pg.AarsmoeteprotokollYear.ee2370')}
                        <ArrowLeft className="w-4 h-4 rotate-180" />
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            /* Upcoming protocol */
            <div className="bg-white rounded-2xl border border-white/10 p-8 sm:p-12 text-center">
              <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <Clock className="w-10 h-10 text-slate-400" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900 mb-4">{t('pg.AarsmoeteprotokollYear.cf7734')}</h2>
              <p className="text-slate-500 max-w-md mx-auto mb-6">
                {t('pg.AarsmoeteprotokollYear.336e03')} {data.year} {t('pg.AarsmoeteprotokollYear.c20edb')}
              </p>
              <div className="bg-slate-100/50 rounded-xl p-4 inline-block">
                <p className="text-slate-400 text-xs uppercase tracking-wider mb-1">{t('pg.AarsmoeteprotokollYear.1fa7a0')}</p>
                <p className="text-slate-900 font-medium">{t('pg.AarsmoeteprotokollYear.4a3458')} {data.year}</p>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Grasrotandelen Banner */}
      <GrasrotandelenBanner />
    </div>
  );
};

export default AarsmoeteprotokollYear;
